var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 171,
    viewBox: "0 0 154 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_177_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3545 3.1519C72.5611 -1.05064 81.4389 -1.05063 88.6456 3.1519L150 38.9304V110.476C150 118.887 145.558 126.66 138.348 130.865L88.6456 159.848C81.4389 164.051 72.5611 164.051 65.3544 159.848L15.6523 130.865C8.44201 126.66 4 118.887 4 110.476V38.9304L65.3545 3.1519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9563 27.4908C72.168 23.2806 81.0554 23.2806 88.2671 27.4908L129.032 51.2893V98.9091C129.032 107.317 124.594 115.086 117.389 119.292L88.2671 136.294C81.0554 140.504 72.168 140.504 64.9563 136.294L35.834 119.292C28.6292 115.086 24.1915 107.317 24.1915 98.9091V51.2893L64.9563 27.4908Z",
    fill: "#F2411F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3223 3.19576C72.5453 -1.03183 81.4547 -1.03182 88.6777 3.19576L150 39.0874L77 82.677L4 39.0874L65.3223 3.19576Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_177_409",
    x: 0,
    y: 0,
    width: 154,
    height: 171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_177_409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_177_409",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.4a51e4365ddaf401fc126abe29b2aa52.svg";
export { ForwardRef as ReactComponent };